/* Webshop switcher (custom-country-selector) – dropdown toggle, vanilla port of Sheepskinhouse.ch's custom.js */
(function () {
  if (window.__ccsInit) return; window.__ccsInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.custom_country_selector .custom-select__btn');
    if (btn) {
      var box = btn.parentElement.querySelector('.custom-select__listbox');
      var open = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.custom_country_selector .custom-select__listbox').forEach(function (l) { if (l !== box) { l.setAttribute('hidden', ''); l.setAttribute('aria-hidden', 'true'); } });
      btn.setAttribute('aria-expanded', String(!open));
      if (box) { box.toggleAttribute('hidden'); box.setAttribute('aria-hidden', String(open)); }
      e.preventDefault(); return;
    }
    if (!e.target.closest('.custom_country_selector')) {
      document.querySelectorAll('.custom_country_selector .custom-select__listbox').forEach(function (l) { l.setAttribute('hidden', ''); l.setAttribute('aria-hidden', 'true'); });
      document.querySelectorAll('.custom_country_selector .custom-select__btn[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });
})();
